export type SavedTeamDraft={id:string;label:string;text:string;updatedAt:number};
type DraftStorage=Pick<Storage,'getItem'|'setItem'>;
const uuid=(v:unknown):v is string=>typeof v==='string'&&/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(v);
export const teamDraftTextLimit=120000;
function storageKey(scope:string):string{
 const parts=scope.split(':');if(parts.length!==2||!parts.every(uuid))throw Error('draft_scope_unavailable');
 return 'flusia:flu:team-drafts:v1:'+scope;
}
function checked(raw:unknown):SavedTeamDraft{
 const d=raw as SavedTeamDraft;
 if(!d||!uuid(d.id)||typeof d.text!=='string'||d.text.length>teamDraftTextLimit||typeof d.label!=='string'||!d.label.trim()||d.label.length>200||!Number.isFinite(d.updatedAt)||d.updatedAt<0)throw Error('draft_storage_invalid');
 // Never restore a delivery state, recipient or instruction from browser storage.
 return {id:d.id,label:d.label,text:d.text,updatedAt:d.updatedAt};
}
export function readTeamDrafts(storage:DraftStorage,scope:string):SavedTeamDraft[]{
 const key=storageKey(scope);let raw:string|null;
 try{raw=storage.getItem(key);}catch{throw Error('draft_storage_unavailable');}
 if(raw===null)return [];
 if(raw.length>4*1024*1024)throw Error('draft_storage_invalid');
 try{
  const data=JSON.parse(raw);
  if(data?.version!==1||data.scope!==scope||!Array.isArray(data.items)||data.items.length>32)throw Error();
  const items=data.items.map(checked);
  if(new Set(items.map((d:SavedTeamDraft)=>d.id)).size!==items.length)throw Error();
  return items.sort((a:SavedTeamDraft,b:SavedTeamDraft)=>b.updatedAt-a.updatedAt);
 }catch{throw Error('draft_storage_invalid');}
}
export function saveTeamDraft(storage:DraftStorage,scope:string,draft:SavedTeamDraft):SavedTeamDraft[]{
 const key=storageKey(scope),clean=checked(draft);
 // Reread before every upsert: editing one draft must not drop another tab's draft.
 const items=readTeamDrafts(storage,scope).filter(d=>d.id!==clean.id);
 if(items.length>=32)throw Error('draft_storage_full');
 items.push(clean);items.sort((a,b)=>b.updatedAt-a.updatedAt);
 const value=JSON.stringify({version:1,scope,items});
 if(value.length>4*1024*1024)throw Error('draft_storage_full');
 try{storage.setItem(key,value);}catch{throw Error('draft_storage_unavailable');}
 return items;
}
